import { Card, Descriptions, Table, Tag } from 'antd';
import React from 'react';
import { formatCurrency } from '../../utils/formatCurrency';
import './styles.scss';

interface IProps {
  licenses: any;
}

const accountTypeLabels: Record<string, string> = {
  PREPAID: 'Pré-pago',
  POSTPAID: 'Pós-pago',
};

const LicenseDetailInfo: React.FC<IProps> = props => {
  const { licenses } = props;
  const detail = licenses.whatsapp_details[0];

  const columns = [
    { title: 'Categoria', dataIndex: 'category', key: 'category' },
    {
      title: 'Limite da Categoria',
      dataIndex: 'limit',
      key: 'limit',
      render: (v: number) => formatCurrency(v),
    },
    {
      title: 'Valor Unitário',
      dataIndex: 'unit',
      key: 'unit',
      render: (v: number) => formatCurrency(v),
    },
  ];

  const dataSource = detail
    ? [
      {
        key: '1',
        category: 'Marketing',
        limit: detail.package_mkt_value,
        unit: detail.unit_mkt_value,
      },
      {
        key: '2',
        category: 'Utilidades',
        limit: detail.package_utl_value,
        unit: detail.unit_utl_value,
      },
      {
        key: '3',
        category: 'Autenticação',
        limit: detail.package_auth_value,
        unit: detail.unit_auth_value,
      },
    ]
    : [];

  const hasUnitValue =
    detail?.unit_value !== null && detail?.unit_value !== undefined;

  return (
    <div style={{ margin: '20px 0', width: '100%' }}>
      <Card key={licenses.id} style={{ width: '100%' }}>
        <Descriptions
          colon
          size="small"
          bordered
          layout="horizontal"
          column={2}
        >
          <Descriptions.Item label="Nome da licença" span={2}>
            {licenses.name || 'WhatsApp Principal'}
          </Descriptions.Item>
          <Descriptions.Item label="Status da licença">
            {licenses.enabled ? (
              <Tag color="success">Habilitada</Tag>
            ) : (
              <Tag color="warning">Desabilitada</Tag>
            )}
          </Descriptions.Item>
          <Descriptions.Item label="Tipo de Conta">
            {accountTypeLabels[licenses.account_type] ||
              licenses.account_type ||
              'Não informado'}
          </Descriptions.Item>

          {licenses.media === 'whatsapp' &&
            detail &&
            (hasUnitValue ? (
              <>
                <Descriptions.Item label="Valor Total do Pacote">
                  {formatCurrency(detail.package_total_value)}
                </Descriptions.Item>
                <Descriptions.Item label="Valor Unitário">
                  {formatCurrency(detail.unit_value)}
                </Descriptions.Item>
              </>
            ) : (
              <Descriptions.Item label="Detalhes do Pacote WhatsApp" span={2}>
                <div style={{ marginBottom: 8 }}>
                  <strong>Valor Total do Pacote:</strong>{' '}
                  {formatCurrency(detail.package_total_value)}
                </div>
                <Table
                  dataSource={dataSource}
                  columns={columns}
                  pagination={false}
                  size="small"
                  bordered
                />
              </Descriptions.Item>
            ))}
        </Descriptions>
      </Card>
    </div>
  );
};

export default LicenseDetailInfo;
